<template>
	 <v-navigation-drawer
	 	app
		fixed
		right
		width="1024"
		temporary
		:class="['mobile-drawer-container-right', 'contain-scroll']"
		hide-overlay
		stateless
		touchless
		disable-route-watcher
	 	v-model.sync="openState">
	 	<template v-if="contentComponent">

	 		<v-btn 
	 			fab small
				:class="['elevation-0', 'close-btn-right']"
				color="primary"
	 			@click="closeMobileDrawerRight">
	 			<v-icon>close</v-icon>
	 		</v-btn>
			<component class="component-container" :is="contentComponent"/>

		</template>
		<template v-else>
			Loading...
		</template>
	 </v-navigation-drawer>
</template>


<script>
	import { mapState, mapActions } from 'vuex'

	import { VUEX_UI_HIDE_MOBILE_DRAWER_RIGHT } from '@/store/constants/ui'

	export default {
		name: 'mobile-drawer-container',

		computed: {
			...mapState({
				content: state => state.ui.mobileDrawerRight.content
			}),	
			
			openState: {
				get() { return this.$store.state.ui.mobileDrawerRight.openState },
				set() { }
			}
		},

		created() {
			this.loadContent()
		},

		methods: {
			...mapActions({
				closeMobileDrawerRight: VUEX_UI_HIDE_MOBILE_DRAWER_RIGHT
			}),

			loadContent() {
				this.contentComponent = (this.content) ? this.$root.loadComponent(this.content) : null
			},
		},

		watch: {
			content: {
				deep: true,
				handler() {
					this.loadContent()	
				}
			}
		}
	}
</script>